export namespace GasUploader {
  export enum Status {
    Default = 'default',
    Loading = 'loading',
    InProgress = 'inProgress',
    Success = 'success',
    Error = 'error',
  }
}
